import { jsxs as C, jsx as l } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const o = (e) => /* @__PURE__ */ C(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_4292_10768)", children: /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.56768 0.780522C1.59868 0.93165 0.905322 1.68717 0.76821 2.74125C0.750018 2.88105 0.744378 5.67691 0.749202 12.168L0.756066 21.396L0.82161 21.6337C1.04807 22.4548 1.61063 22.9684 2.53895 23.2016C2.6884 23.2391 3.36523 23.2426 11.8801 23.2501C18.4044 23.2558 21.1272 23.2505 21.2921 23.2319C21.5969 23.1975 21.8045 23.1368 22.0681 23.0051C22.6368 22.7208 23.0078 22.2271 23.1901 21.5119L23.2441 21.3V11.976C23.2441 3.25264 23.2414 2.64009 23.2029 2.46729C23.1044 2.02576 22.9326 1.71179 22.621 1.40399C22.3858 1.1716 22.1183 1.00699 21.7984 0.89781C21.3108 0.731442 22.111 0.743754 11.9549 0.746322C4.44743 0.748218 2.73477 0.754458 2.56768 0.780522ZM2.74807 2.27843C2.50838 2.33678 2.34611 2.52938 2.28163 2.83199C2.26031 2.93193 2.25525 5.18457 2.26077 12.108L2.26807 21.252L2.31806 21.36C2.38214 21.4984 2.50372 21.6044 2.6801 21.6755L2.82007 21.732L4.78207 21.7387L6.74407 21.7453V12.0007V2.25599L4.78207 2.25844C3.70295 2.25981 2.78767 2.26879 2.74807 2.27843ZM8.25607 12V21.7444L14.7541 21.7382L21.2521 21.732L21.3601 21.682C21.4985 21.6179 21.6045 21.4963 21.6756 21.32L21.7321 21.18L21.7382 12.0126C21.7451 1.68583 21.764 2.67249 21.5554 2.47199C21.4936 2.41259 21.3893 2.34239 21.3236 2.31599C21.2052 2.26847 21.1409 2.26792 14.7301 2.26178L8.25607 2.25556V12Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_4292_10768", children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  o as LayoutLeftIcon
};
//# sourceMappingURL=LayoutLeftIcon.js.map
